import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';
import { useGoogleLogin } from '@react-oauth/google';
import { FaGoogle } from 'react-icons/fa';
import { formatGoogleAuthError, googleOriginHint } from '../utils/googleAuthErrors';
import { trackMetaCompleteRegistration } from '../utils/analytics';
import '../StylesComponents/signin-page.css';

function SignInPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleGoogleSuccess = async (tokenResponse) => {
    console.log('📡 GOOGLE_RESPONSE_RECEIVED');
    
    try {
      const res = await api.post('/api/auth/google', { 
        token: tokenResponse.access_token 
      });
      
      const data = res.data;
      console.log('✅ AUTH_SUCCESS // WELCOME', data.user.username);
      
      localStorage.setItem('token', data.accessToken);
      localStorage.setItem('user', JSON.stringify(data.user));
      if (data.isNewUser) trackMetaCompleteRegistration();
      onLogin(data.user);
      navigate('/');
    } catch (err) {
      console.error('❌ GOOGLE_LOGIN_BACKEND_ERROR:', err);
      const serverError = err.response?.data?.error || err.message;
      alert(`Authentication failed: ${serverError}`);
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => handleGoogleSuccess(tokenResponse),
    onError: (error) => {
      console.error('❌ GOOGLE_LOGIN_LIBRARY_ERROR:', error);
      const detail = formatGoogleAuthError(error);
      alert(`Google sign-in failed: ${detail}\n\n${googleOriginHint()}`);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/auth/signin', { email, password });
      const data = response.data;

      // Store the accessToken in localStorage
      localStorage.setItem('token', data.accessToken);
      localStorage.setItem('user', JSON.stringify(data.user));

      // Call the onLogin function to update the app state
      onLogin(data.user);

      // Redirect to the home page or admin page
      navigate('/');
    } catch (error) {
      console.error('Error during sign in:', error);
      const errorMessage = error.response?.data?.error || 'Sign In failed. Please check your credentials.';
      alert(errorMessage);
    }
  };

  return (
    <div className="signin-page-wrapper">
      <div className="signin-container glass-card animate-slide-up">
        <div className="signin-status-tag">
          <span className="pulse-dot"></span>
          SECURE AUTHENTICATION SYSTEM
        </div>
        <h1 className="signin-heading">SIGN IN</h1>
        <form className="signin-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">EMAIL ADDRESS</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ENTER EMAIL"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">PASSWORD</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="ENTER PASSWORD"
              required
            />
          </div>

          <button type="submit" className="brutalist-btn brutalist-btn-primary signin-button">
            SIGN IN TO ACCOUNT
          </button>
        </form>

        <div className="social-auth-separator">
          <span className="separator-line"></span>
          <span className="separator-text">OR_CONNECT_VIA_SOCIAL</span>
          <span className="separator-line"></span>
        </div>

        <div className="social-auth-grid" style={{ gridTemplateColumns: '1fr' }}>
          <button className="social-auth-btn google" type="button" onClick={() => {
            console.log('🚀 INITIATING_GOOGLE_FLOW...');
            googleLogin();
          }}>
            <FaGoogle /> SIGN_IN_WITH_GOOGLE
          </button>
        </div>

        <div className="auth-links">
          <div className="signup-link">
            <p>NO ACCOUNT? <Link to="/signup">CREATE ONE HERE</Link></p>
          </div>

          <div className="forgot-password-link">
            <p><Link to="/forgot-password">RECOVER PASSWORD</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignInPage;
